import { IBaseGrid } from "Grids/Interfaces";
import { ServiceProvider } from "Service";
import { GridSettings } from "Configuration/GridSettings";
import { BaseGridDefinition, Environment } from "Service/Client";

/**
 * @hidden
 */
export type GridFactory = (
    gridDefinition: BaseGridDefinition,
    textBlockCategory: string,
    gridSettings: GridSettings,
    serviceProvider: ServiceProvider,
    environment: Environment
) => IBaseGrid;

/**
 * Defines all available configurations for one GridType.
 */
export class GridTypeConfiguration {
    private _factory: GridFactory;
    private _gridSettings: GridSettings;

    /**
     * Create a new Configuration for a GridType.
     * @param factory Factory for the Grid.
     * @param gridSettings Configuration settings.
     */
    constructor(factory: GridFactory, gridSettings: GridSettings) {
        this._factory = factory;
        this._gridSettings = gridSettings;
    }

    /**
     * The factory for creating instances of this GridType.
     * @hidden
     */
    public get factory(): GridFactory {
        return this._factory;
    }

    /**
     * The settings which are passed to the grid.
     */
    public get gridSettings(): GridSettings {
        return this._gridSettings;
    }
}
